import { render, staticRenderFns } from "./VehicleRecentRoutes.vue?vue&type=template&id=0f44bae5&scoped=true&"
import script from "./VehicleRecentRoutes.vue?vue&type=script&lang=js&"
export * from "./VehicleRecentRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f44bae5",
  null
  
)

export default component.exports